import {FiAlertCircle} from "react-icons/fi";
import {Link} from "react-router";

import {Icon} from "@/components/icon/Icon.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {SLAReport} from "@/lib/queries/reports.ts";

interface ScheduledReportNameCellProps {
  report?: SLAReport;
}

export const ScheduledReportNameCell = ({report}: ScheduledReportNameCellProps) => {
  return report ? (
    <Tooltip tooltipContent={report.name} delayMs={1000}>
      <div className="ellipsis-overflow">
        <Link to={`/reports/sla/${report.id}`}>{report.name}</Link>
      </div>
    </Tooltip>
  ) : (
    <span className="text-danger">
      <Icon icon={FiAlertCircle} display="inline" removeDivDimensions /> No report selected
    </span>
  );
};
